import { cn } from '@/lib/utils'

export default function DotBackgroundDemo() {
  return (
    <div
      className={`
        relative flex h-full w-full items-center justify-center bg-gray-100
        dark:bg-black
      `}
    >
      <div
        className={cn(
          'absolute inset-0',
          'bg-size-[20px_20px]',
          'bg-[radial-gradient(#d4d4d4_1px,transparent_1px)]',
          'dark:bg-[radial-gradient(#404040_1px,transparent_1px)]',
        )}
      />
    </div>
  )
}
